/**
 * Length measurement computation.
 *
 * Computes centerline-following distances between two nodes.
 */

import { findPathContainingNodes } from './path-resolver';
import type { Centerline } from '../../centerline';

export interface LengthResult {
    /** Distance in mm along the centerline */
    readonly value: number;
    /** Node ID of the from-endpoint */
    readonly fromNodeId: number;
    /** Node ID of the to-endpoint */
    readonly toNodeId: number;
}

/**
 * Compute centerline-following distance between two nodes.
 *
 * Finds the path containing both nodes and uses pre-computed cumulative distances.
 */
export function computeLength(
    fromNodeId: number,
    toNodeId: number,
    centerlines: ReadonlyMap<string, Centerline>
): LengthResult | null {
    const resolved = findPathContainingNodes(fromNodeId, toNodeId, centerlines);
    if (!resolved) return null;

    const { centerline, indexA, indexB } = resolved;
    const value = centerline.getLengthBetween(indexA, indexB);

    return { value, fromNodeId, toNodeId };
}
